// extracted by mini-css-extract-plugin
export default {"search_section":"SpecialistInput_search_section__fbAqF","search_input":"SpecialistInput_search_input__kmA-S"};